// ============================================================================
// Trial access list
// ----------------------------------------------------------------------------
// Shared gating logic. Defines which interventions + library practices are
// reachable based on the user's billing status.
//
//   billingStatus === "trialing" → only TRIAL_ACCESS_IDS are unlocked
//   billingStatus === "expired"  → EVERYTHING is locked (paywall everywhere)
//   any other status (active / waived / null / undefined) → everything open
//
// Trial *active* gives the user a curated taste of the library; trial *over*
// must hard-stop access to every practice and route them to subscribe.
// ============================================================================

// IDs match both intervention `type` keys and library-practice `id` values.
export const TRIAL_ACCESS_IDS = new Set([
  "quiet_the_worry",
  "dial_down_tension",
  "forest-tones",
  "deep-calm-432hz",
  "mindfulness-of-breath",
]);

// True when the given practice or intervention id is locked for this user.
export const isLockedForUser = (id, billingStatus) => {
  if (billingStatus === "expired") {
    // Trial is over and no active subscription — every practice locked.
    return true;
  }
  if (billingStatus === "trialing") {
    // Active trial — only the curated taste-test is unlocked.
    return !TRIAL_ACCESS_IDS.has(id);
  }
  // active / waived / null / undefined — everything unlocked.
  return false;
};

// True when the user has lost access entirely (trial over, no subscription).
// Used by paywall views to swap their copy and CTAs.
export const isTrialExpired = (billingStatus) => billingStatus === "expired";
